import { cn } from '@woonstad/helpers-utils';
import { forwardRef } from 'react';

type Props = React.AriaAttributes & {
  children: React.ReactNode | React.ReactNode[];
  className?: string;
  noShadow?: boolean;
  'data-testid'?: string;
};

export const BoxBase = forwardRef((
  {
    children,
    className,
    noShadow = false,
    'data-testid': testid,
  }: Props,
  ref?: React.Ref<HTMLDivElement>,
) => {
  const classes = cn(
    'border border-card-link-enabled bg-surface-default text-base-primary-on-light',
    !noShadow && 'shadow-box transition-shadow',
    className,
  );

  return (
    <div
      ref={ref}
      className={classes}
      data-testid={testid}
    >
      {children}
    </div>
  );
});

BoxBase.displayName = 'BoxBase';
